import {combineReducers} from "redux";
import list from './list';
import update from './update.js'

export default combineReducers({list, update});
